import { CommonModule, NgFor } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar";

@Component({
    selector: 'app-notification',
    imports: [
        CommonModule,
        MatIcon,
        MatIconButton,
        //NgFor
    ],
    templateUrl: './notification.component.html',
    styleUrl: './notification.component.css'
})


export class NotificationComponent {
    messages: string[] = [];

    type: string = 'info';

    constructor(public snackBarRef: MatSnackBarRef<NotificationComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data: any) {

        console.log('NotificationComponent initialized', data);

        this.messages = this.data.messages;
        this.type = this.data.type || 'info';
        console.log(this.messages);
        console.log(this.type);
    }

    removeMessage(message: string) {
        this.messages.splice(this.messages.indexOf(message), 1);
        if (this.messages.length === 0) {
            this.snackBarRef.dismiss();
        }
    }
}
